export * from './wig-weekly-competition-details.module';
